import React, { useMemo } from 'react';
import { alpha, Box, CustomTheme, useTheme } from '@mui/material';
import { PodiumEntry } from './components/PodiumEntry';
import { PodiumEmptyPlaceholder } from './components/PodiumEmptyPlaceholder';
import { getOrderedPodiumEntries } from './helpers';
import { IRankingPodiumOverlay } from './interfaces';

export const RankingPodiumOverlay: React.FC<IRankingPodiumOverlay> = ({
  podium,
  enrollmentCount,
  size = 'default',
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  const orderedEntries = useMemo(
    () => getOrderedPodiumEntries(podium),
    [podium]
  );

  const hasRanking = orderedEntries.length > 0;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        pointerEvents: 'none',
        background: `linear-gradient(to top, ${alpha(theme.palette.primary.main, 0.88)} 0%, ${alpha(theme.palette.primary.main, 0.45)} 55%, ${alpha(theme.palette.primary.main, 0.1)} 100%)`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          gap: 1,
          px: 1.5,
          pb: 1.5,
        }}
      >
        {hasRanking ? (
          orderedEntries.map((entry) => (
            <PodiumEntry key={entry.member.slug} entry={entry} size={size} />
          ))
        ) : (
          <PodiumEmptyPlaceholder enrollmentCount={enrollmentCount} />
        )}
      </Box>
    </Box>
  );
};
